export default __webpack_public_path__ + "static/media/rocket_anim_101.e9a06d38.png";